var __defProp = Object.defineProperty;
var __getProtoOf = Object.getPrototypeOf;
var __reflectGet = Reflect.get;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var __superGet = (cls, obj, key) => __reflectGet(__getProtoOf(cls), key, obj);
var _targetSafe, _ctx, _updatePropHeaders, updatePropHeaders_fn, _acceptUpdates, acceptUpdates_fn, _set, set_fn, _updateSections, updateSections_fn, _elements, _updateDataStore, updateDataStore_fn, _getButtonOperation, getButtonOperation_fn;
const curr_symbol_map = {
  AED: "د.إ",
  AFN: "؋",
  ALL: "L",
  AMD: "֏",
  ANG: "ƒ",
  AOA: "Kz",
  ARS: "$",
  AUD: "$",
  AWG: "ƒ",
  AZN: "₼",
  BAM: "KM",
  BBD: "$",
  BDT: "৳",
  BGN: "лв",
  BHD: ".د.ب",
  BIF: "FBu",
  BMD: "$",
  BND: "$",
  BOB: "$b",
  BOV: "BOV",
  BRL: "R$",
  BSD: "$",
  BTC: "₿",
  BTN: "Nu.",
  BWP: "P",
  BYN: "Br",
  BYR: "Br",
  BZD: "BZ$",
  CAD: "$",
  CDF: "FC",
  CHE: "CHE",
  CHF: "CHF",
  CHW: "CHW",
  CLF: "CLF",
  CLP: "$",
  CNH: "¥",
  CNY: "¥",
  COP: "$",
  COU: "COU",
  CRC: "₡",
  CUC: "$",
  CUP: "₱",
  CVE: "$",
  CZK: "Kč",
  DJF: "Fdj",
  DKK: "kr",
  DOP: "RD$",
  DZD: "دج",
  EEK: "kr",
  EGP: "£",
  ERN: "Nfk",
  ETB: "Br",
  ETH: "Ξ",
  EUR: "€",
  FJD: "$",
  FKP: "£",
  GBP: "£",
  GEL: "₾",
  GGP: "£",
  GHC: "₵",
  GHS: "GH₵",
  GIP: "£",
  GMD: "D",
  GNF: "FG",
  GTQ: "Q",
  GYD: "$",
  HKD: "$",
  HNL: "L",
  HRK: "kn",
  HTG: "G",
  HUF: "Ft",
  IDR: "Rp",
  ILS: "₪",
  IMP: "£",
  INR: "₹",
  IQD: "ع.د",
  IRR: "﷼",
  ISK: "kr",
  JEP: "£",
  JMD: "J$",
  JOD: "JD",
  JPY: "¥",
  KES: "KSh",
  KGS: "лв",
  KHR: "៛",
  KMF: "CF",
  KPW: "₩",
  KRW: "₩",
  KWD: "KD",
  KYD: "$",
  KZT: "₸",
  LAK: "₭",
  LBP: "£",
  LKR: "₨",
  LRD: "$",
  LSL: "M",
  LTC: "Ł",
  LTL: "Lt",
  LVL: "Ls",
  LYD: "LD",
  MAD: "MAD",
  MDL: "lei",
  MGA: "Ar",
  MKD: "ден",
  MMK: "K",
  MNT: "₮",
  MOP: "MOP$",
  MRO: "UM",
  MRU: "UM",
  MUR: "₨",
  MVR: "Rf",
  MWK: "MK",
  MXN: "$",
  MXV: "MXV",
  MYR: "RM",
  MZN: "MT",
  NAD: "$",
  NGN: "₦",
  NIO: "C$",
  NOK: "kr",
  NPR: "₨",
  NZD: "$",
  OMR: "﷼",
  PAB: "B/.",
  PEN: "S/.",
  PGK: "K",
  PHP: "₱",
  PKR: "₨",
  PLN: "zł",
  PYG: "Gs",
  QAR: "﷼",
  RMB: "￥",
  RON: "lei",
  RSD: "Дин.",
  RUB: "₽",
  RWF: "R₣",
  SAR: "﷼",
  SBD: "$",
  SCR: "₨",
  SDG: "ج.س.",
  SEK: "kr",
  SGD: "S$",
  SHP: "£",
  SLL: "Le",
  SOS: "S",
  SRD: "$",
  SSP: "£",
  STD: "Db",
  STN: "Db",
  SVC: "$",
  SYP: "£",
  SZL: "E",
  THB: "฿",
  TJS: "SM",
  TMT: "T",
  TND: "د.ت",
  TOP: "T$",
  TRL: "₤",
  TRY: "₺",
  TTD: "TT$",
  TVD: "$",
  TWD: "NT$",
  TZS: "TSh",
  UAH: "₴",
  UGX: "USh",
  USD: "$",
  UYI: "UYI",
  UYU: "$U",
  UYW: "UYW",
  UZS: "лв",
  VEF: "Bs",
  VES: "Bs.S",
  VND: "₫",
  VUV: "VT",
  WST: "WS$",
  XAF: "FCFA",
  XBT: "Ƀ",
  XCD: "$",
  XOF: "CFA",
  XPF: "₣",
  XSU: "Sucre",
  XUA: "XUA",
  YER: "﷼",
  ZAR: "R",
  ZMW: "ZK",
  ZWD: "Z$",
  ZWL: "$"
};
class currencyAPI {
  constructor(currencyCode = "$") {
    var _a, _b, _c, _d;
    try {
      const _win = globalThis.window;
      if (_win.Shopify && ((_b = (_a = _win.Shopify) == null ? void 0 : _a.currency) == null ? void 0 : _b.active)) {
        this.rate = 0.01;
        const curr_code = (_d = (_c = _win.Shopify) == null ? void 0 : _c.currency) == null ? void 0 : _d.active;
        this.symbol = curr_symbol_map[curr_code] ?? "$";
        this.moneyFormat = `${this.symbol}{{amount}}`;
      } else if (_win.theme && _win.theme.settings && _win.theme.settings.currency) {
        const rate = _win.theme.settings.currency.rate ?? "0.01";
        this.rate = parseFloat(rate);
        this.moneyFormat = _win.theme.settings.currency.moneyFormat ?? "${{amount}}";
        this.superScript = _win.theme.settings.currency.superScript ?? false;
      }
    } catch (err) {
      this.rate = 0.01;
      this.symbol = curr_symbol_map[currencyCode] ?? "$";
      this.moneyFormat = `${this.symbol}{{amount}}`;
      this.superScript = false;
    }
  }
  money(price, precision) {
    return (price * this.rate).toFixed(precision ?? 2);
  }
  toPrice(money) {
    return (money / this.rate).toFixed(0);
  }
  formatMoney(price, format = this.moneyFormat) {
    if (!format)
      format = this.moneyFormat;
    if (typeof price === "string") {
      price = price.replace(".", "");
    }
    var value = "";
    const _price = parseInt(price);
    let placeholderRegex = /\{\{+\s*(\w[^\}]+)\s*\}\}/;
    const mode = format.match(placeholderRegex);
    switch (mode[1]) {
      case "amount":
        value = this.formatWithDelimiters(_price, 2);
        if (this.superScript && value && value.includes(".")) {
          value = value.replace(".", "<sup>") + "</sup>";
        }
        break;
      case "amount_no_decimals":
        value = this.formatWithDelimiters(_price, 0);
        break;
      case "amount_with_comma_separator":
        value = this.formatWithDelimiters(_price, 2, ".", ",");
        if (this.superScript && value && value.includes(",")) {
          value = value.replace(",", "<sup>") + "</sup>";
        }
        break;
      case "amount_no_decimals_with_comma_separator":
        value = this.formatWithDelimiters(_price, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = this.formatWithDelimiters(_price, 0, " ");
        break;
    }
    const money = format.replace(placeholderRegex, value);
    return money;
  }
  formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) {
      return "0";
    }
    const money = this.money(number, precision);
    var parts = money.split(".");
    var dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands
    );
    var centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
}
class coolDataAPI {
  constructor(coolData, eventTarget = null, namespace = null, targetSafe = false) {
    __privateAdd(this, _updatePropHeaders);
    __privateAdd(this, _acceptUpdates);
    __privateAdd(this, _set);
    __privateAdd(this, _targetSafe, false);
    __privateAdd(this, _ctx, null);
    this.coolData = coolData;
    this.namespace = namespace ?? "coolData";
    this.eventName = (propName) => `${this.namespace}:${propName}`;
    __privateSet(this, _ctx, eventTarget ?? null);
    this.propHeaders = {};
    __privateSet(this, _targetSafe, targetSafe ?? false);
  }
  static getAttrNames(props, namespace) {
    return props.map((prop) => `data-${namespace}-${prop}`);
  }
  getPropNames() {
    return Object.values(this.propHeaders).map((obj) => obj.propName);
  }
  getPropAttrNames() {
    return Object.values(this.propHeaders).map((obj) => obj.attrName);
  }
  get(prop) {
    return this.coolData[prop] ?? null;
  }
  getCurrData() {
    const valsObj = {};
    Object.entries(this.coolData).forEach(
      ([key, value]) => valsObj[key] = value.value
    );
    return valsObj;
  }
  create(prop, value) {
    const propObj = this.coolData[prop];
    if (propObj) {
      throw new Error(`${prop} already exists.`);
    }
    __privateMethod(this, _updatePropHeaders, updatePropHeaders_fn).call(this, prop);
    __privateMethod(this, _set, set_fn).call(this, prop, value);
    __privateMethod(this, _acceptUpdates, acceptUpdates_fn).call(this, prop);
  }
  update(prop, value) {
    const propObj = this.coolData[prop];
    if (!propObj) {
      throw new Error(`${prop} doesn't exist.`);
    }
    __privateMethod(this, _set, set_fn).call(this, prop, value);
  }
  createMany(obj) {
    Object.entries(obj).forEach(([prop, val]) => this.create(prop, val));
  }
  updateMany(obj) {
    Object.entries(obj).forEach(([prop, val]) => __privateMethod(this, _set, set_fn).call(this, prop, val, false));
    Object.entries(obj).forEach(([prop, val]) => this.dispatchChange(prop));
  }
  dispatchChange(prop, ctx = __privateGet(this, _ctx)) {
    ctx.dispatchEvent(
      new CustomEvent(this.eventName(prop), {
        detail: this.coolData[prop]
      })
    );
    if (!__privateGet(this, _targetSafe)) {
      ctx.setAttribute(
        this.propHeaders[prop].attrName,
        JSON.stringify(this.coolData[prop].value)
      );
    }
  }
  listen(prop, handler) {
    __privateGet(this, _ctx).addEventListener(
      this.propHeaders[prop].dispatchEventName,
      (e) => handler(e.detail)
    );
  }
  listenAll(handler) {
    this.getPropNames().forEach((prop) => this.listen(prop, handler));
  }
}
_targetSafe = new WeakMap();
_ctx = new WeakMap();
_updatePropHeaders = new WeakSet();
updatePropHeaders_fn = function (prop) {
  this.propHeaders[prop] = {
    propName: prop,
    attrName: `data-${this.namespace}-${prop}`,
    dispatchEventName: this.eventName(prop),
    updateEventName: `${this.eventName(prop)}-update`
  };
};
_acceptUpdates = new WeakSet();
acceptUpdates_fn = function (prop) {
  __privateGet(this, _ctx).addEventListener(
    this.propHeaders[prop].updateEventName,
    (e) => this.update(prop, e.detail.value)
  );
};
_set = new WeakSet();
set_fn = function (prop, value, dispatch = true) {
  const propObj = this.coolData[prop];
  if (propObj) {
    propObj.oldValue = propObj.value ?? null;
    propObj.value = value;
  } else {
    this.coolData[prop] = {
      value,
      oldValue: null
    };
  }
  if (dispatch)
    this.dispatchChange(prop);
};
class Drawer extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.config = {
      trigger_selectors: this.dataset.triggers.trim().split(" ") ?? [
        `${this.tagName}-trigger`
      ]
    };
  }
  connectedCallback() {
    this.registerTriggers();
  }
  registerTriggers() {
    var drawer = this;
    this.triggers = this.config.trigger_selectors.map(
      (trigger_sel) => Array.from(document.querySelectorAll(trigger_sel))
    ).flat();
    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        drawer.isOpen.call(drawer) ? drawer.close.call(drawer) : drawer.open.call(drawer);
      });
    });
  }
  afterOpenCallback() {
  }
  afterCloseCallback() {
  }
  /*
      Adds class named "{drawer-tagname}-open" to all triggers 
      that are registered with this drawer.
  
      Adds class named "open" to the drawer itself waits 50ms
      for drawer animations calls the afterOpenCallback
      */
  async open() {
    return new Promise((res, rej) => {
      this.triggers.forEach(
        (trigger) => trigger.classList.add(`${this.tagName.toLowerCase()}-open`)
      );
      setTimeout(() => {
        this.classList.add("open");
        document.body.classList.add("!overflow-hidden");
      }, 50);
      res(0);
    }).then(() => {
      this.afterOpenCallback();
    });
  }
  async close() {
    return new Promise((res, rej) => {
      this.triggers.forEach(
        (trigger) => trigger.classList.remove(`${this.tagName.toLowerCase()}-open`)
      );
      this.classList.remove("open");
      document.body.classList.remove("!overflow-hidden");
      res(0);
    }).then((val) => {
      this.afterCloseCallback();
    });
  }
  isOpen() {
    return this.classList.contains("open");
  }
}
class CartDrawer extends Drawer {
  constructor() {
    super();
    var comp = this;
    this.config = {
      ...this.config ?? [],
      sectionId: this.dataset.sectionId
    };
    this.selectors = {
      data: "#CartDrawerCartData",
      mainItems: "[data-main-items]",
      cartTotalOriginalPrice: "price-quote[data-cart-total-original-price]",
      cartTotalDiscountPrice: "price-quote[data-cart-total-discount-price]",
      cartTotalPrice: "price-quote[data-cart-total-price]",
      reRenderInner: "[data-render-inner]",
      lineItemCount: "[data-line-item-count]",
      itemCount: "[data-cart-item-count]",
      itemCountIcon: "[data-cart-item-count-icon]"
    };
    this.elements = {
      freebiesMeter: this.querySelector("freebies-meter"),
      mainItems: this.querySelector(this.selectors.mainItems),
      reRenderInner: this.querySelectorAll(this.selectors.reRenderInner),
      subTotalQuote: this.querySelectorAll(
        "price-quote[data-cart-subtotal]"
      ),
      recommendedProducts: () => this.querySelectorAll("recommended-products")
    };
    this.data = {};
    this.dataStore = new coolDataAPI(this.data, this, "cart-drawer");
    this.getData = function (cartObj) {
      this.cart = cartObj;
      const {
        items,
        item_count,
        original_total_price,
        total_price,
        total_discount
      } = cartObj;
      this.prices = {
        original_total_price,
        total_price,
        total_discount
      };
      this.items = {
        items,
        item_count,
        line_item_count: items.length
      };
    };
    this.getSectionDOM = function (sectionsObj) {
      const _html = sectionsObj ? sectionsObj[comp.config.sectionId] : null;
      this.sectiondom = _html ? new window.DOMParser().parseFromString(_html, "text/html") : null;
    };
    const ds = this.dataStore;
    ds.createMany({
      ...new this.getData(
        JSON.parse(
          document.querySelector("#CartDrawerCartData").innerText
        )
      ),
      sectiondom: null
    });
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (!newValue)
      return;
    switch (name) {
      case "data-cart-drawer-prices": {
        this.reRenderSubtotalPrice(this.data.prices.value);
        break;
      }
      case "data-cart-drawer-items":
        this.onItemCountChange(oldValue, newValue);
        break;
      case "data-cart-drawer-sectiondom": {
        this.reRenderMainItems(this.data.sectiondom.value);
        this.reRenderInner(this.data.sectiondom.value);
        break;
      }
    }
  }
  connectedCallback() {
    super.connectedCallback();
    if (!themeStore)
      console.error("themeStore is missing, non-ideal behaviour.");
    themeStore == null ? void 0 : themeStore.dataStore.listen("cart", (data) => {
      const { cart, sections } = themeStore.dataStore.getCurrData();
      this.dataStore.updateMany({
        ...new this.getData(cart),
        ...new this.getSectionDOM(sections)
      });
    });
    themeStore == null ? void 0 : themeStore.dataStore.listen("sections", (data) => {
      const { sections } = themeStore.dataStore.getCurrData();
      const sectionDOM = new this.getSectionDOM(sections).sectiondom;
      if (sectionDOM) {
        const cart = JSON.parse(
          sectionDOM.querySelector(".CartData").innerText
        );
        this.dataStore.updateMany({
          ...new this.getData(cart),
          sectiondom: sectionDOM
        });
      }
    });
  }
  afterOpenCallback() {
    document.querySelector("body").style.overflow = "hidden";
  }
  afterCloseCallback() {
    document.querySelector("body").style.overflow = "auto";
  }
  replaceAllInnerText(selector, value, doc_ctx = true) {
    let ctx = doc_ctx ? document : this;
    ctx.querySelectorAll(selector).forEach((node) => {
      node.innerText = value;
    });
  }
  reRenderSubtotalPrice(newPrices) {
    const prices = this.data.prices.value;
    Object.entries(prices).forEach(([key, price]) => {
      prices[key] = currencyAPIObj.formatMoney(price);
    });
    const {
      cartTotalPrice: totalPrice,
      cartTotalDiscountPrice: totalDiscountPrice,
      cartTotalOriginalPrice: totalOriginalPrice
    } = this.selectors;
    this.replaceAllInnerText(totalPrice, prices.total_price, true);
    this.replaceAllInnerText(totalDiscountPrice, prices.total_discount, true);
    this.replaceAllInnerText(
      totalOriginalPrice,
      prices.original_total_price,
      true
    );
  }
  onItemCountChange(oldVal, newVal) {
    const { value: newItemDat, oldValue: oldItemData } = this.data.items;
    this.replaceAllInnerText(
      this.selectors.lineItemCount,
      newItemDat.line_item_count
    );
    document.querySelectorAll(this.selectors.itemCount).forEach((node) => {
      node.textContent = newItemDat.item_count;
    });
    document.querySelectorAll(this.selectors.itemCountIcon).forEach((node) => {
      node.textContent = newItemDat.item_count > 0 ? newItemDat.item_count > 9 ? '9+' : newItemDat.item_count : '';

      let parent = node.parentElement;
      if (parent) {
        parent.title = `Cart items: ${newItemDat.item_count}`;
      }
    });
    if (newItemDat.item_count === 0) {
      this.classList.add("cart-is-empty");
    } else {
      this.classList.remove("cart-is-empty");
    }
    return 0;
  }
  async reRenderMainItems(newSectionDOM) {
    if (newSectionDOM === null)
      return -1;
    this.elements.mainItems.innerHTML = newSectionDOM.querySelector(
      this.selectors.mainItems
    ).innerHTML;
    return 0;
  }
  async reRenderInner(newSectionDOM) {
    if (newSectionDOM === null)
      return -1;
    this.elements.reRenderInner.forEach((element, index) => {
      element.innerHTML = newSectionDOM.querySelectorAll(
        this.selectors.reRenderInner
      )[index].innerHTML;
    });
    return 0;
  }
}
__publicField(CartDrawer, "observedAttributes", [
  ...coolDataAPI.getAttrNames(
    ["cart", "items", "prices", "sectiondom"],
    "cart-drawer"
  )
]);
class HandleFormDataObj {
  constructor(formDataObj) {
    __publicField(this, "updateFormItems", (item) => {
      this.formData.items[item.id] = item;
      return this.formData;
    });
    __publicField(this, "updateSelectors", (selectors) => {
      this.formData.selectors = selectors;
      return this.formData;
    });
    __publicField(this, "getUpdatesObj", () => {
      let updatesObj = Object.values(this.formData.items).map((ele) => ({
        [ele.id]: parseInt(ele.quantity)
      })).reduce((tar, obj) => ({ ...tar, ...obj }), {});
      return { updates: updatesObj, attributes: this.formData.attributes };
    });
    __publicField(this, "getAddObj", () => {
      let itemsArr = Object.values(this.formData.items);
      return { items: itemsArr };
    });
    __publicField(this, "deleteItem", (item_key) => {
      delete this.formData.items[item_key];
    });
    this.formData = formDataObj;
  }
}
class HandleFormDataJSON {
  constructor(datasetObj, name = "form") {
    this.name = name;
    this.data = datasetObj;
    this.formData = { items: {}, selectors: [] };
    this.empty();
    this.getObj();
    this.APIobj = new HandleFormDataObj(this.formData);
  }
  getObj() {
    const _newdata = JSON.parse(this.data[this.name]);
    if (this.formData)
      this.formData = Object.assign(this.formData, _newdata);
    return _newdata;
  }
  setObj() {
    this.data[this.name] = JSON.stringify(this.formData);
  }
  updateItems(item) {
    this.APIobj.updateFormItems(item);
    if (!(JSON.stringify(this.formData) === this.data[this.name]))
      this.setObj();
  }
  updateManyItems(items) {
    items.forEach((item) => this.APIobj.updateFormItems(item));
    if (!(JSON.stringify(this.formData) === this.data[this.name]))
      this.setObj();
  }
  updateAttributes(attributes) {
    var _a;
    const _oldAttrs = ((_a = this.formData) == null ? void 0 : _a.attributes) ?? {};
    this.formData.attributes = { ..._oldAttrs, ...attributes };
    this.setObj();
  }
  deleteItem(item_key) {
    this.APIobj.deleteItem(item_key);
    this.setObj();
  }
  updateSelectors(selectors) {
    this.formData.selectors.push(...selectors);
  }
  getUpdatesObj() {
    return this.APIobj.getUpdatesObj();
  }
  getAddObj() {
    return this.APIobj.getAddObj();
  }
  getSelectors() {
    return this.formData.selectors;
  }
  empty() {
    this.formData = Object.assign(this.formData, {
      items: {},
      selectors: [],
      attributes: {}
    });
    this.setObj();
  }
  items() {
    this.getObj();
    let _items = 0;
    Object.values(this.formData.items).forEach((_obj, _i) => {
      _items += parseInt(`${_obj.quantity}`);
    });
    return _items;
  }
  isEmpty() {
    var _a;
    return Object.keys(this.formData.items).length === 0 && ((_a = Object.keys(this.formData.attributes)) == null ? void 0 : _a.length) === 0;
  }
}
window.HandleFormDataJSON = HandleFormDataJSON;
var CartFormSettingsConsts = {
  openOn: {
    click: "click",
    res: "res"
  }
};
class CartForm extends HTMLElement {
  constructor() {
    super();
    this.config = {
      type: this.dataset.type || "add"
    };
    this.selectors = {
      addToCartButton: 'button[type="addToCart"]'
    };
    this.sectionId = this.dataset.sectionId;
    this.formDataAPI = new HandleFormDataJSON(this.dataset);
    this.getCartDrawer = () => document.querySelector("cart-drawer") || null;
    this.openCartDrawer = () => {
      var _a;
      if (this.getCartDrawer() && !location.pathname.includes("/cart")) {
        (_a = this.getCartDrawer()) == null ? void 0 : _a.open.call(this.getCartDrawer());
      }
    };
  }
  static get observedAttributes() {
    return ["data-form"];
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data-form" && oldValue !== newValue && oldValue) {
      if (this.dataset.type === "update" && !this.formDataAPI.isEmpty()) {
        this.reqCart();
      }
    }
  }
  connectedCallback() {
    this.config = {
      ...this.config,
      sectionsToRender: this.getSectionsToRender() || [this.sectionId],
      responseHandlers: this.dataset.type === "add" ? this.addCart() : this.updateCart()
    };
    this.setupCheckoutButton();
    this.setupAddToCartButtons();
  }
  getSectionsToRender() {
    const sectionsToRender = [];
    if (this.getCartDrawer()) {
      sectionsToRender.push(this.getCartDrawer().sectionId);
    }
    if (this.dataset.sectionsToRender) {
      sectionsToRender.push(...this.dataset.sectionsToRender.trim().split(" "));
    }
    return sectionsToRender;
  }
  async reqCart() {
    var _a;
    this.beforeRequestSetup();
    try {
      if (!location.pathname.includes("/cart") && ((_a = window.CartFormSettings) == null ? void 0 : _a.openOn) === CartFormSettingsConsts.openOn.click) {
        this.openCartDrawer();
      }
    } catch (err) {
      console.error("Failed to open the cart-drawer", err);
    }
    try {
      const response = await fetch(window.Shopify.routes.root + `cart/${this.config.type}.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(this.getPayload())
      });
      const data = await response.json();
      if (response.ok) {
        this.signalUpdate(data);
        await this.config.responseHandlers.dataHandler(data);
      } else {
        await this.config.responseHandlers.errorHandler(data);
      }
    } catch (error) {
      this.onNetworkError(error);
    } finally {
      this.afterResponseCleanUp();
    }
  }
  getPayload() {
    const payload = this.config.type === "update" ? this.formDataAPI.getUpdatesObj() : this.formDataAPI.getAddObj();
    payload.sections = this.getSectionsToRender();
    this.dispatchEvent(new CustomEvent("/cart-form:payload", {
      bubbles: true,
      detail: { type: this.config.type, payload }
    }));
    return payload;
  }
  beforeRequestSetup() {
    var _a;
    this.classList.add("loading");
    (_a = this.getCartDrawer()) == null ? void 0 : _a.classList.add("loading");
  }
  afterResponseCleanUp() {
    var _a, _b, _c;
    this.classList.remove("loading");
    (_a = this.getCartDrawer()) == null ? void 0 : _a.classList.remove("loading");
    if (this.config.type === "update") {
      this.formDataAPI.empty();
    }
    try {
      if (!location.pathname.includes("/cart") && (((_b = window.CartFormSettings) == null ? void 0 : _b.openOn) === CartFormSettingsConsts.openOn.res || !((_c = window.CartFormSettings) == null ? void 0 : _c.openOn))) {
        this.openCartDrawer();
      }
    } catch (err) {
      console.error("Failed to open the cart-drawer", err);
    }
  }
  onNetworkError(error) {
    console.error("Bad Network! try again later!", error);
  }
  onUnhandledError(error) {
    console.error("Fatal! Unforeseen Cart-form error has occurred.", error);
    this.dispatchEvent(new CustomEvent("/cart-form:res:error", {
      bubbles: true,
      detail: error
    }));
  }
  updateCart() {
    return {
      dataHandler: async (data) => {
        this.replaceMainCart(data.sections);
        this.openCartDrawer();
      },
      errorHandler: async (errData) => {
        console.error(errData.message, errData.description);
      }
    };
  }
  addCart() {
    return {
      dataHandler: async (data) => {
        this.replaceMainCart(data.sections);
        this.openCartDrawer();
      },
      errorHandler: (errData) => {
        console.error(errData.message, errData.description);
      }
    };
  }
  signalUpdate(data) {
    this.dispatchEvent(new CustomEvent("/cart-form:res", {
      bubbles: true,
      detail: { type: this.config.type, res: data }
    }));
  }
  setupCheckoutButton() {
    var _a;
    this.checkoutButton = this.querySelector('button[name="checkout"]');
    (_a = this.checkoutButton) == null ? void 0 : _a.addEventListener("click", (event) => {
      event.preventDefault();
      if (this.config.type === "add") {
        this.reqCart().then(() => {
          document.location.href = "/checkout";
        });
      } else {
        document.location.href = "/checkout";
      }
    });
  }
  setupAddToCartButtons() {
    if (this.dataset.type === "add" || this.dataset.type === "create") {
      this.addToCartButtons = Array.from(this.querySelectorAll(this.selectors.addToCartButton));
      this.addToCartButtons.forEach((addToCartButton) => {
        if (!addToCartButton.hasAttribute("for") || addToCartButton.getAttribute("for") === this.getAttribute("id")) {
          addToCartButton.addEventListener("click", (e) => {
            e.preventDefault();
            this.reqCart();
          });
        }
      });
    }
  }
  replaceMainCart(sections) {
    if ("main-cart" in sections) {
      const mainCartElement = document.querySelector("#main-cart .main-cart-items");
      if (mainCartElement) {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = sections["main-cart"];

        const newMainCartItems = tempDiv.querySelector(".main-cart-items");
        if (newMainCartItems) {
          mainCartElement.innerHTML = newMainCartItems.innerHTML;
        }
      }
    }
  }
}
class LineItem extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      form: "cart-form",
      plusButton: ".plus-button",
      removeButton: ".delete-button",
      minusButton: ".minus-button",
      quantityInput: ".quantity-input"
    };
    this.cartForm = () => this.closest(this.selectors.form);
    this.getItemData = () => {
      return {
        id: this.dataset.id,
        quantity: this.dataset.quantity
      };
    };
    this.setQuantityAttribute = (newVal) => this.dataset.quantity = newVal;
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue || !oldValue && this.cartForm().dataset.type == "update") {
      return;
    }
    if (name == "data-quantity") {
      this.onQuantityChange(oldValue, newValue);
    } else if (name == "data-id") {
      this.onIdChange(oldValue, newValue);
    }
  }
  connectedCallback() {
    this.item = this.getItemData;
    this.setupQuantitySelector();
  }
  UpdateFormData() {
    this.cartForm().formDataAPI.updateManyItems([this.getItemData(), ...this.getLinkedGiftItems()]);
  }
  getLinkedGiftItems() {
    const { gwpUid, gwpRole } = this.dataset;
    if (!gwpUid || gwpRole !== "parent" || this.cartForm().dataset.type !== "update")
      return [];
    return Array.from(
      this.cartForm().querySelectorAll(`line-item[data-gwp-role="gift"][data-gwp-uid="${CSS.escape(gwpUid)}"]`)
    ).map((giftLine) => {
      giftLine.classList.add("loading");
      return { id: giftLine.dataset.id, quantity: this.dataset.quantity };
    });
  }
  setLoadingState() {
    if (this.cartForm().dataset.type === "update") {
      this.classList.add("loading");
    }
  }
  onQuantityChange(old_quantity, new_quantity) {
    this.setLoadingState();
    if (new_quantity === "0" && this.cartForm().dataset.type === "add") {
      this.cartForm().formDataAPI.deleteItem(this.dataset.id);
    } else {
      this.UpdateFormData();
    }
  }
  onIdChange(oldId, newId) {
    this.setLoadingState();
    this.cartForm().formDataAPI.deleteItem(oldId);
    this.UpdateFormData();
  }
  setupQuantitySelector() {
    var _a, _b;
    var comp = this;
    this.quantityInput = this.querySelector(this.selectors.quantityInput) ?? null;
    this.buttons = this.querySelectorAll(
      ".delete-button,.plus-button,.minus-button"
    ) ?? null;
    (_a = this.buttons) == null ? void 0 : _a.forEach((button) => {
      (() => {
        if (button.classList.contains("plus-button"))
          var getval = (val) => `${val >= 0 ? val + 1 : 0}`;
        else if (button.classList.contains("minus-button")) {
          var getval = (val) => `${val > 0 ? val - 1 : 0}`;
        } else if (button.classList.contains("delete-button")) {
          var getval = (val) => `0`;
        }
        const updateVal = () => {
          const _q = parseInt(getval(this.tempVal));
          if (!this.validateQuantity(_q))
            return;
          this.tempVal = _q;
          if (comp.quantityInput)
            comp.quantityInput.value = parseInt(this.tempVal);
        };
        const sendVal = (val) => {
          this.dataset.quantity = val;
          this.tempVal = parseInt(this.dataset.quantity);
        };
        let timeout, quantInterval;
        const onMouseUp = (e) => {
          e.stopImmediatePropagation();
          clearTimeout(timeout);
          clearInterval(quantInterval);
          sendVal(this.tempVal);
        };
        button.addEventListener("mousedown", (e) => {
          e.stopImmediatePropagation();
          this.tempVal = parseInt(this.dataset.quantity);
          updateVal();
          timeout = setTimeout(() => {
            quantInterval = setInterval(() => {
              updateVal();
            }, 250);
          }, 300);
        });
        button.addEventListener("mouseup", onMouseUp);
      })();
    });
    (_b = this.quantityInput) == null ? void 0 : _b.addEventListener("change", (event) => {
      event.stopImmediatePropagation();
      let val = parseInt(event.target.value);
      if (isNaN(val))
        event.target.value = 0;
      this.dataset.quantity = val;
    });
  }
  validateQuantity(new_quant) {
    return true;
  }
}
__publicField(LineItem, "observedAttributes", ["data-quantity", "data-id"]);
class PriceQuote extends HTMLElement {
  constructor() {
    super();
    this.currencyAPIObj = window.currencyAPIObj;
    this.config = {
      curr_flag: this.dataset.hideCurrency == "true",
      format: this.dataset.format ?? null
    };
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (!newValue)
      return;
    this.reRender({ name, oldVal: oldValue, newVal: newValue });
  }
  reRender({ name = null, oldVal = null, newVal = null } = null) {
    if (!name) {
      this.setPrice();
      this.setMoney();
    }
    if (oldVal !== newVal) {
      switch (name) {
        case "data-price": {
          this.setMoney(newVal);
          break;
        }
        case "data-money": {
          this.setMoney(newVal * 100);
          break;
        }
      }
    }
  }
  setMoney(price) {
    if (this.config.curr_flag)
      this.textContent = price;
    else
      this.textContent = this.currencyAPIObj.formatMoney(
        price,
        this.config.format
      );
  }
}
__publicField(PriceQuote, "observedAttributes", [
  "data-price",
  "data-money",
  "data-show-currency"
]);
const _Utils = class _Utils {
  constructor() {
  }
};
__publicField(_Utils, "eventNames", {
  cartUpdate: "themeStore:cart"
});
__publicField(_Utils, "getCartRoutes", function () {
  return [
    "/cart/add.js",
    "/cart/add.json",
    "/cart/add",
    "/cart/change.js",
    "/cart/change.json",
    "/cart/change",
    "/cart/clear.js",
    "/cart/clear.json",
    "/cart/clear",
    "/cart/update.js",
    "/cart/update.json",
    "/cart/update"
  ];
});
__publicField(_Utils, "isValidUrl", function (url) {
  if (canParse(url)) {
    const [store_URL, url_URL] = [window.location.origin, url].map(
      (_url) => new URL(_url, window.location.origin)
    );
    return [
      store_URL.hostname === url_URL.hostname && _Utils.getCartRoutes().some(
        (path) => url_URL.pathname.includes(path)
      ),
      url_URL
    ];
  }
  return [false, void 0];
});
let Utils = _Utils;
function canParse(url) {
  try {
    new URL(url);
    return true;
  } catch (e) {
    return false;
  }
}
class themeStoreClass extends EventTarget {
  constructor() {
    var _a, _b, _c;
    super();
    __privateAdd(this, _updateSections);
    this.config = {
      cartPageReload: ((_b = (_a = window.theme) == null ? void 0 : _a.settings) == null ? void 0 : _b.cartPageReload) ?? false
    };
    this.selectors = {
      cartDrawer: "cart-drawer"
    };
    this.config.cartDrawerSectionId = ((_c = document.querySelector(this.selectors.cartDrawer)) == null ? void 0 : _c.dataset.sectionId) ?? null;
    this.data = {};
    this.dataStore = new coolDataAPI(this.data, this, "themeStore", true);
    this.dataFromRes = function (res_data) {
      this.cart = { ...res_data };
      if (this.cart.sections) {
        this.sections = this.cart.sections;
        delete this.cart.sections;
      }
    };
    this.dataStore.create("cart", this.fetchCart());
    this.dataStore.create("sections", null);
    this.dataStore.create("error", null);
    this.setupListeners();
  }
  setupListeners() {
    this.extendFetch();
    if (this.config.cartPageReload) {
      this.dataStore.listen("cart", (data) => {
        if (location.pathname.includes("/cart")) {
          this.refreshPage();
        }
      });
    }
  }
  refreshPage() {
    if (this.data.cart.oldValue)
      window.document.location = "";
  }
  extendFetch() {
    const store = this;
    const proxy = async (res) => {
      let data;
      const abs_url = res.url;
      const [isValid, urlObj] = Utils.isValidUrl(abs_url);
      if (!isValid)
        return -1;
      if (!res.ok) {
        try {
          this.dataStore.update("error", await res.json());
          return -1;
        } catch (err) {
          console.log(err);
        }
      } else {
        data = await res.json();
      }
      const _data = { cart: data, sections: data.sections ?? {} };
      if (_data.cart !== this.data.value) {
        if (urlObj.pathname.includes("add")) {
          _data.cart = await store.fetchCart.apply(store);
        }
        if (_data.sections) {
          const _sections = _data.sections;
          if (this.cartDrawerSectionId) {
            const cd_id = this.config.cartDrawerSectionId;
            if (!_sections[cd_id]) {
              _sections[cd_id] = await fetch(
                `/?sections=${cd_id}`
              ).then((res2) => res2.json()).then((sections) => sections[cd_id]);
            }
          }
        }
        store.dataStore.updateMany({
          cart: _data.cart,
          sections: _data.sections
        });
      }
      return 0;
    };
    const _oldfetch = window.fetch;
    window.fetch = async function storeFetch(...args) {
      return _oldfetch(...args).then((res) => {
        proxy(res.clone());
        return res;
      });
    };
  }
  async fetchCart() {
    const data = await fetch("/cart.json").then((res) => res.json()).then((data2) => {
      return data2;
    });
    return data;
  }
}
_updateSections = new WeakSet();
updateSections_fn = function (sectionsObj) {
  const _sec = { ...this.data.sections.value };
  Object.entries(sectionsObj).forEach(([section, html]) => {
    _sec[section] = html;
  });
  this.dataStore.update("sections", _sec);
};
let themeStore$1;
if (!window.themeStore) {
  themeStore$1 = new themeStoreClass();
  window.themeStore = themeStore$1;
} else {
  themeStore$1 = window.themeStore;
}
const themeStore$2 = themeStore$1;
class RecommendedProducts extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.config = {
      ids: this.dataset.recProdId.split("__").map((id) => parseInt(id.trim())),
      intent: this.dataset.recProdIntent ?? "related",
      limit: parseInt(this.dataset.recProdLimit) ?? 4
    };
    this.selectors = {
      recContainer: "[data-recommendations-container]",
      prodContainer: "[data-product-container]",
      heading: "[data-recommendations-heading]"
    };
    this.data = {};
    this.dataStore = new coolDataAPI(this.data, this, "rec-prod");
    this.dataStore.createMany({
      ...this.config
    });
    this.dataStore.listen("ids", this.render.bind(this));
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (!oldValue || !newValue || oldValue === newValue)
      return;
    const prop = name.match("(?:(?:[^-\n])(?!-))+$")[0];
    let val = newValue;
    if (typeof this.data[prop].value !== "string")
      val = JSON.parse(val);
    if (val !== this.data[prop].value)
      this.dataStore.update(prop, val);
  }
  connectedCallback() {
    this.render();
    this.setup();
  }
  render() {
    const { ids, limit, intent } = this.dataStore.getCurrData();
    if (!ids)
      return;
    this.classList.add("loading");
    Promise.all(this.getRecommendationsPromises(ids, intent)).then(
      (recommendationsArray) => this.processRecommendations(recommendationsArray, limit)
    ).catch((error) => {
      console.error(
        "Error fetching or rendering recommendations:",
        error
      );
    });
  }
  getRecommendationsPromises(product_ids, intent) {
    return Array.from(product_ids).map((id) => {
      const themeRoot = window.Shopify.routes.root;
      if (themeRoot === "/") {
        const recommendationsUrl2 = `/recommendations/products?product_id=${id}&section_id=${this.sectionId}&intent=${intent}`;
        return this.fetchRecommendations(recommendationsUrl2, intent);
      }
      const recommendationsUrl = `${window.Shopify.routes.root}/recommendations/products?product_id=${id}&section_id=${this.sectionId}&intent=${intent}`;
      return this.fetchRecommendations(recommendationsUrl, intent);
    });
  }
  fetchRecommendations(url) {
    return fetch(url).then((response) => response.text()).then((text) => {
      const _html = new window.DOMParser().parseFromString(
        text,
        "text/html"
      );
      const recommendations = _html.querySelector(
        this.selectors.recContainer
      );
      return recommendations && recommendations.innerHTML.trim().length ? recommendations : null;
    }).catch((error) => {
      console.error("Error fetching recommendations:", error);
      return null;
    });
  }
  processRecommendations(recommendationsArray, limit) {
    let _nodeArr = recommendationsArray.filter((_arr) => _arr !== null);
    const _recProds = _nodeArr.map((recNode) => {
      return Array.from(
        recNode.querySelectorAll(this.selectors.prodContainer)
      );
    }).flat();
    const uniqueProductIds = new Set(
      _recProds.map((productNode) => productNode.dataset.productId)
    );
    const uniqProds = Array.from(uniqueProductIds).map(
      (id) => _recProds.find((prodNode) => id === prodNode.dataset.productId)
    ).slice(0, limit);
    const headingElements = document.querySelectorAll(
      this.selectors.heading
    );
    if (uniqProds.length > 0) {
      headingElements.forEach((node) => {
        node.classList.add("!block");
      });
    } else {
      headingElements.forEach((node) => {
        node.classList.remove("!block");
      });
    }
    const allRecommendationsHTML = uniqProds.map((node) => node.outerHTML).join("");
    this.querySelector(this.selectors.recContainer).innerHTML = allRecommendationsHTML;
    return 0;
  }
  setup() {
  }
}
__publicField(RecommendedProducts, "observedAttributes", [
  ...coolDataAPI.getAttrNames(["ids", "limit", "intent"], "rec-prod")
]);
class CartDrawerRecommendations extends RecommendedProducts {
  //data = {}
  //dataStore = new coolDataAPI(this.data, this, "rec-prod")
  constructor() {
    super();
    __privateAdd(this, _elements, {});
  }
  setup() {
    themeStore == null ? void 0 : themeStore.dataStore.listen("cart", (data) => {
      const productIds = data.value.items.map((item) => item.product_id);
      if (productIds && productIds !== this.data.ids.value) {
        this.dataStore.update("ids", productIds);
      }
    });
  }
}
_elements = new WeakMap();
class ProductCardImages extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      productCard: "product-card",
      featuredImage: "#featured-image"
    };
    this.elements = {
      productCard: this.closest(this.selectors.productCard),
      featuredImage: () => this.querySelector(this.selectors.featuredImage)
    };
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (!newValue)
      return;
    this.render();
  }
  render() {
    const _clone = this.elements.featuredImage().cloneNode(true);
    _clone.src = this.dataset.src;
    this.elements.featuredImage().outerHTML = _clone.outerHTML;
  }
  connectedCallback() {
    this.elements.productCard.dataStore.listen(
      "media",
      this.handleProductChange.bind(this)
    );
  }
  handleProductChange(data) {
    const { images } = data.value;
    this.dataset.src = images[0].src;
  }
}
__publicField(ProductCardImages, "observedAttributes", ["data-src"]);
class ProductCardProductPrice extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      productCard: "product-card",
      originalPrice: "[data-original-price]",
      compareAtPrice: "[data-compare-at-price]",
      finalPrice: "[data-final-price]"
    };
    this.elements = {
      productCard: this.closest(this.selectors.productCard),
      originalPriceQuote: this.querySelectorAll(
        this.selectors.originalPrice
      ),
      compareAtQuote: this.querySelectorAll(this.selectors.compareAtPrice),
      finalPriceQuote: this.querySelectorAll(this.selectors.finalPrice)
    };
    this.data = {};
    this.dataStore = new coolDataAPI(this.data, this, "prod-price");
    this.productDS = this.elements.productCard.dataStore;
    this.dataStore.create("price", this.productDS.getCurrData().price);
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (!newValue)
      return;
    this.render();
  }
  connectedCallback() {
    var _a;
    (_a = this.productDS) == null ? void 0 : _a.listen("price", (data) => {
      this.dataStore.update("price", data.value);
    });
  }
  render() {
    this.elements.originalPriceQuote.forEach((el) => {
      el.dataset.price = this.data.price.value.price;
    });
    this.elements.compareAtQuote.forEach((el) => {
      el.dataset.price = this.data.price.value.compare_at_price;
    });
    this.elements.finalPriceQuote.forEach((el) => {
      el.dataset.price = this.data.price.value.quantity_price;
    });
  }
}
__publicField(ProductCardProductPrice, "observedAttributes", ["data-prod-price-price"]);
const _ProductCardCustomBulkPrice = class _ProductCardCustomBulkPrice extends ProductCardProductPrice {
  constructor() {
    var _a;
    super();
    this.dataStore.create("quantity", this.productDS.getCurrData().quantity);
    this.selectors = {
      ...this.selectors,
      bulkDiscountPrice: "[data-bulk-discount-price]",
      tiersNode: "[data-tiers]"
    };
    this.config = {
      ...this.config,
      /**
       * Nested array of bulk discount tiers in format [[min_quantity, discount_price/discount_percentage]]
       * min_quantity(int): The minimum quantity required to get the discount
       * discount_price(string): The discounted price or percentage for the product
       */
      tiers: JSON.parse((_a = this.querySelector(this.selectors.tiersNode)) == null ? void 0 : _a.innerText.trim())
    };
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (!newValue)
      return;
    this.render();
  }
  connectedCallback() {
    var _a;
    super.connectedCallback();
    (_a = this.productDS) == null ? void 0 : _a.listen("quantity", (data) => {
      this.dataStore.update("quantity", data.value);
    });
  }
  render() {
    super.render();
    this.querySelectorAll(this.bulkDiscountPrice).forEach((el) => {
      el.dataset.price = this.getTierDiscountPrice();
    });
  }
  /**
   * Get the bulk discount price of the product
   * It assumes that the elements of tiers are sorted in ascending order.
   * @returns {number} The bulk disount price on the product depending on the quantity
   */
  getTierDiscountPrice() {
    const tier = this.config.tiers.find(
      (tier2) => tier2.quantity >= this.data.quantity.value
    );
    const original_price = this.data.price.value.price;
    if (!tier)
      return original_price;
    if (typeof tier[1] === "string") {
      if (tier[1].includes("%")) {
        const discount_ratio = parseFloat(tier[1].replace("%", "")) / 100;
        return original_price * (1 - discount_ratio);
      } else {
        return original_price - parseFloat(tier[1]);
      }
    }
  }
};
__publicField(_ProductCardCustomBulkPrice, "observedAttributes", [
  ...__superGet(_ProductCardCustomBulkPrice, _ProductCardCustomBulkPrice, "observedAttributes"),
  "data-prod-price-quantity"
]);
let ProductCardCustomBulkPrice = _ProductCardCustomBulkPrice;
class ProductCardQuantitySelector extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _updateDataStore);
    __privateAdd(this, _getButtonOperation);
    this.config = {
      min_quantity: this.dataset.minQuantity ? parseInt(this.dataset.minQuantity) : 1
      // data-min-quantity
    };
    this.selectors = {
      productCard: "product-card",
      plusButton: ".plus-button",
      removeButton: ".delete-button",
      minusButton: ".minus-button",
      quantityInput: ".quantity-input"
    };
    this.elements = {
      productCard: this.closest(this.selectors.productCard),
      quantityInput: this.querySelector(this.selectors.quantityInput) ?? null,
      plusButtons: Array.from(
        this.querySelectorAll(`${this.selectors.plusButton}`) ?? null
      ),
      minusButtons: Array.from(
        this.querySelectorAll(`${this.selectors.minusButton}`) ?? null
      ),
      removeButtons: Array.from(
        this.querySelectorAll(`${this.selectors.removeButton}`) ?? null
      ),
      buttons: Array.from(
        this.querySelectorAll(
          `${this.selectors.removeButton},${this.selectors.plusButton},${this.selectors.minusButton}`
        ) ?? null
      )
    };
    this.dataStore = {};
    this.dataStoreAPI = new coolDataAPI(
      this.dataStore,
      this,
      "quantity-selector"
    );
    this.dataStoreAPI.create(
      "quantity",
      parseInt(this.elements.productCard.data.quantity.value) ?? 1
    );
  }
  attributeChangedCallback(name, oldValue, newValue) {
  }
  connectedCallback() {
    this.setQuantityInputVals(this.dataStore.quantity.value);
    this.setupQuantitySelector();
    this.dataStoreAPI.listen("quantity", (data) => {
      this.setQuantityInputVals(data.value);
    });
  }
  setQuantityInputVals(quantity) {
    if (this.elements.quantityInput)
      this.elements.quantityInput.value = quantity;
    this.elements.quantityInput.setAttribute("value", quantity);
  }
  validateQuantity(new_quant) {
    return true;
  }
  internalValidation(new_quant) {
    return !(new_quant < this.config.min_quantity);
  }
  updateProductCardQuantity() {
    this.elements.productCard.dataStore.update(
      "quantity",
      this.dataStore.quantity.value
    );
  }
  setupQuantitySelector() {
    var _a, _b;
    (_a = this.elements.buttons) == null ? void 0 : _a.forEach((button) => {
      const getval = __privateMethod(this, _getButtonOperation, getButtonOperation_fn).call(this, button);
      let timeout, quantInterval;
      button.addEventListener("mousedown", (e) => {
        e.stopImmediatePropagation();
        const _q = () => parseInt(getval(this.dataStore.quantity.value));
        __privateMethod(this, _updateDataStore, updateDataStore_fn).call(this, _q());
        timeout = setTimeout(() => {
          quantInterval = setInterval(() => {
            __privateMethod(this, _updateDataStore, updateDataStore_fn).call(this, _q());
          }, 250);
        }, 300);
      });
      const onMouseUp = (e) => {
        e.stopImmediatePropagation();
        clearTimeout(timeout);
        clearInterval(quantInterval);
        this.updateProductCardQuantity();
      };
      button.addEventListener("mouseup", onMouseUp);
    });
    (_b = this.elements.quantityInput) == null ? void 0 : _b.addEventListener("change", (event) => {
      event.stopImmediatePropagation();
      let val = parseInt(event.target.value);
      if (isNaN(val)) {
        event.target.value = 0;
        event.target.setAttribute("value", 0);
        val = 0;
      }
      __privateMethod(this, _updateDataStore, updateDataStore_fn).call(this, val);
      this.updateProductCardQuantity();
    });
  }
}
_updateDataStore = new WeakSet();
updateDataStore_fn = function (val) {
  if (this.internalValidation(val) && this.validateQuantity(val)) {
    this.dataStoreAPI.update("quantity", val);
  }
};
_getButtonOperation = new WeakSet();
getButtonOperation_fn = function (button) {
  const { minusButtons, plusButtons, removeButtons } = this.elements;
  let getval;
  if (plusButtons.includes(button)) {
    getval = (val) => `${val >= 0 ? val + 1 : 0}`;
  } else if (minusButtons.includes(button)) {
    getval = (val) => `${val > 0 ? val - 1 : 0}`;
  } else if (removeButtons.includes(button)) {
    getval = (val) => `0`;
  }
  return getval;
};
__publicField(ProductCardQuantitySelector, "observedAttributes", ["quantity-selector-quantity"]);
class ProductCardVariantSelector extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "getSelectedOption", function (selected_variant) {
      const { options, product } = this.dataStore.getCurrData();
      return selected_variant ? selected_variant.options : product.variants[0].options;
    });
    __publicField(this, "getVariant", function (selected_options, option_variant_map) {
      let selected_variant_id = null;
      if (!selected_options.some((option) => option == void 0)) {
        selected_variant_id = option_variant_map[JSON.stringify(selected_options)];
      }
      this.selected_variant_id = selected_variant_id;
    });
    var comp = this;
    this.config = {
      dontRender: this.dataset.doNotRender !== void 0 ? true : false
    };
    this.selectors = {
      productCard: "product-card",
      container: ".container",
      optionTemplate: "#option-template",
      optionValButtons: "[data-option-value]"
    };
    this.elements = {
      productCard: this.closest(this.selectors.productCard),
      container: this.querySelector(this.selectors.container),
      optionTemplate: this.querySelector(this.selectors.optionTemplate),
      optionValButtons: () => this.querySelectorAll(this.selectors.optionValButtons)
    };
    this.utils = {
      transpose: (m) => m[0].map((x, i) => m.map((x2) => x2[i]))
    };
    this.data = {};
    this.dataStore = new coolDataAPI(this.data, this, "variant-selector");
    this.getOptions = function (product) {
      const variants = product.variants;
      const option_vals = comp.utils.transpose(variants.map((variant) => variant.options)).map((vals) => [...new Set(vals)]);
      let options = {};
      product.options.forEach((option_type, index) => {
        options[option_type] = option_vals[index];
      });
      let option_variant_map = {};
      variants.forEach((variant) => {
        option_variant_map[JSON.stringify(variant.options)] = variant.id;
      });
      this.options = {
        options,
        option_variant_map
      };
    };
    this.productCardDataStore = this.elements.productCard.dataStore;
    const productObj = this.productCardDataStore.coolData.product.value;
    const selected_variant = this.productCardDataStore.coolData.selected_variant.value;
    this.dataStore.createMany({
      product: productObj,
      ...new this.getOptions(productObj)
    });
    this.dataStore.createMany({
      selected_option: this.getSelectedOption(selected_variant),
      ...new this.getVariant(
        this.getSelectedOption(selected_variant),
        this.data.options.value.option_variant_map
      )
    });
  }
  connectedCallback() {
    if (!this.config.dontRender) {
      this.render();
    }
    this.refreshSelected();
    this.elements.productCard.dataStore.listen("product", (data) => {
      const product = data.value;
      this.dataStore.update("product", product);
      this.dataStore.updateMany(new this.getOptions(product));
      this.dataStore.updateMany({
        selected_option: this.getSelectedOption(null),
        ...new this.getVariant(
          this.getSelectedOption(null),
          this.data.options.value.option_variant_map
        )
      });
      if (!this.config.dontRender) {
        this.render();
      }
      this.refreshSelected();
    });
    this.dataStore.listen("selected_option", (data) => {
      this.dataStore.updateMany(
        new this.getVariant(
          data.value,
          this.data.options.value.option_variant_map
        )
      );
      this.refreshSelected();
    });
    this.dataStore.listen("selected_variant_id", (data) => {
      var _a;
      this.productCardDataStore.updateMany({
        selected_variant_id: data.value
      });

      if (data.value) {
        const url = new URL(window.location.href);

        if (url.search) {
          url.searchParams.set("variant", data.value);
        } else {
          url.search = `?variant=${data.value}`;
        }
        history.replaceState(null, "", url.toString());
      }

      if (this.elements.productCard.config.type === "update-variant-select" && data.value !== null) {
        (_a = this.closest("cart-form").addToCartButtons[0]) == null ? void 0 : _a.dispatchEvent(
          new Event("click")
        );
        this.unselect();
      }
    });
    this.attachEventListenersToVariants();
  }
  refreshSelected() {
    this.elements.optionValButtons().forEach((variant) => variant.classList.remove("selected"));
    const { options } = this.data.options.value;
    const selected_option = this.data.selected_option.value;
    Object.keys(options).forEach((option_type, index) => {
      this.querySelectorAll(
        `[data-option-type="${option_type}"][data-option-value="${selected_option[index]}"]`
      ).forEach((node) => node.classList.add("selected"));
    });
  }
  attachEventListenersToVariants() {
    const { options } = this.data.options.value;
    Object.keys(options).forEach((option_type, index) => {
      this.querySelectorAll(
        `select[data-option-type="${option_type}"]`
      ).forEach((select_ele) => {
        select_ele.addEventListener("change", (e) => {
          const option_val = e.target.value;
          this.updateSelectedVariant(option_type, option_val);
        });
      });
    });
    Object.keys(options).forEach((option_type, index) => {
      this.querySelectorAll(
        `[data-option-type="${option_type}"]`
      ).forEach((node) => {
        if (node.tagName !== "SELECT") {
          node.addEventListener("click", (e) => {
            this.updateSelectedVariant(option_type, node.dataset.optionValue);
          });
        }
      });
    });
  }
  updateSelectedVariant(option_type, option_val) {
    const { options } = this.data.options.value;
    const option_types = Object.keys(options);
    let selected_option = this.data.selected_option.value;
    selected_option[option_types.indexOf(option_type)] = option_val;
    this.dataStore.update("selected_option", selected_option);
  }
  render() {
    this.elements.container.innerHTML = "";
    const { options } = this.data.options.value;
    Object.entries(options).forEach(([option_type, option_vals], index) => {
      const optionNodeClone = this.elements.optionTemplate.content.cloneNode(true);
      const optionPlaceHolders = optionNodeClone.querySelectorAll("[data-option-type]");
      const optionValTemplate = optionNodeClone.querySelector(
        "#option-value-template"
      );
      const optionValsContainer = optionNodeClone.querySelector(
        ".option-vals-container"
      );
      optionPlaceHolders.forEach((ph) => ph.textContent = option_type);
      option_vals.forEach((option_val) => {
        const optionValueNodeClone = optionValTemplate.content.cloneNode(true);
        optionValueNodeClone.querySelectorAll("[data-option-value]").forEach((node) => {
          node.textContent = option_val;
          node.dataset.optionValue = option_val;
          node.dataset.optionType = option_type;
        });
        optionValsContainer.appendChild(optionValueNodeClone);
      });
      this.elements.container.appendChild(optionNodeClone);
    });
  }
  unselect() {
    this.dataStore.updateMany({
      selected_option: this.getSelectedOption(null),
      ...new this.getVariant(
        this.getSelectedOption(null),
        this.data.options.value.option_variant_map
      )
    });
  }
}
__publicField(ProductCardVariantSelector, "observedAttributes", ["data-variant", "data-option-array"]);
class ProductCardProductSelector extends HTMLElement {
  constructor() {
    var _a;
    super();
    this.config = {};
    this.selectors = {
      productCard: "product-card",
      productsListData: ".ProductSelector--product_list",
      productOptions: "[data-product-option]",
      productOption: (id) => `[data-product-option][data-id="${id}"]`
    };
    this.elements = {
      productCard: this.closest(this.selectors.productCard),
      productsListData: this.querySelector(
        this.selectors.productsListData
      ),
      productOptionList: this.querySelectorAll(
        this.selectors.productOptions
      ),
      productOption: (id) => this.querySelector(this.selectors.productOption(id))
    };
    this.data = {};
    this.dataStore = new coolDataAPI(
      this.data,
      this,
      "product-selector"
    );
    this.dataStore.create(
      "productsList",
      JSON.parse((_a = this.elements.productsListData) == null ? void 0 : _a.innerText) ?? []
    );
    this.dataStore.create("selected_product", {});
    this.productCardDataStore = this.elements.productCard.coolDataAPIObj;
  }
  attributeChangedCallback(name, oldVal, newVal) {
    this.onSelectedProductIdChange(oldVal, newVal);
    this.render();
  }
  connectedCallback() {
    const _selprod = this.dataset.selectedProductId ? this.findProductById(this.dataset.selectedProductId) : null;
    this.setSelectedProduct(_selprod);
    this.elements.productOptionList.forEach((optionNode) => {
      optionNode.addEventListener("click", (e) => {
        this.setSelectedProduct(e.target.dataset.id);
      });
    });
  }
  findProductById(id) {
    return this.data.productsList.value.filter(
      (prod) => `${prod.id}` === id
    )[0];
  }
  onSelectedProductIdChange(oldId, newId) {
    if (oldId === newId)
      return;
    const new_prod = this.findProductById(newId);
    if (typeof new_prod !== "undefined") {
      this.productCardDataStore.update("product", new_prod);
    }
  }
  setSelectedProduct(product) {
    this.dataStore.update("selected_product", product);
  }
  render() {
    this.classList.toggle("open");
    this.elements.productOptionList.forEach(
      (_o) => _o.classList.remove("selected")
    );
    this.elements.productOption(this.dataset.selectedProductId).classList.add("selected");
  }
}
__publicField(ProductCardProductSelector, "observedAttributes", ["data-selected-product-id"]);
class ProductCard extends HTMLElement {
  constructor() {
    var _a;
    super();
    var comp = this;
    this.config = {
      type: this.dataset.type ?? "add",
      defaultVariantId: this.dataset.defaultVariantId ?? "first"
    };
    this.selectors = {
      form: "cart-form",
      updateDispatches: "[data-product-card-updates]"
    };
    this.elements = {
      cartForm: () => this.closest(this.selectors.form),
      productDataNode: this.querySelector(
        "script.ProductCard--selected_product"
      ),
      updateDispatchTargets: () => this.querySelectorAll(this.selectors.updateDispatches)
    };
    this.data = {};
    this.dataStore = new coolDataAPI(this.data, this, "product-card");
    this.dataStore.createMany({
      product: JSON.parse((_a = this.elements.productDataNode) == null ? void 0 : _a.innerText),
      quantity: this.dataset.productCardQuantity ?? 1
    });
    let initial_selected_variant = null, initial_selected_variant_id = null;
    if (this.config.defaultVariantId === "first") {
      initial_selected_variant = this.getFirstProductVariant();
    } else {
      initial_selected_variant_id = parseInt(this.config.defaultVariantId);
      initial_selected_variant = this.data.product.value.variants.filter(
        (x) => x.id == initial_selected_variant_id
      )[0];
    }
    this.newProductData = function (product) {
      var _a2;
      this.product = product;
      this.selected_variant = initial_selected_variant;
      this.selected_variant_id = initial_selected_variant_id ? initial_selected_variant_id : initial_selected_variant.id;
      this.available = initial_selected_variant.available;
      this.media = {
        media: product == null ? void 0 : product.media,
        images: (_a2 = product == null ? void 0 : product.media) == null ? void 0 : _a2.filter(
          (media) => media.media_type === "image"
        )
      };
      this.price = {
        price: this.selected_variant.price,
        discount: null,
        compare_at_price: null,
        discounted_price: null,
        quantity_price: this.selected_variant.price * comp.data.quantity.value,
        discounted_quantity_price: null
      };
    };
    const _dat = new this.newProductData(this.data.product.value);
    delete _dat.product;
    this.dataStore.createMany(_dat);
    this.availibilityUpdate(this.data.available.value);
    this.getItemData = () => {
      return {
        id: this.data.selected_variant_id.value,
        quantity: this.data.quantity.value
      };
    };
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue || !oldValue && this.elements.cartForm().dataset.type == "update") {
      return;
    }
    if (name == "data-product-card-selected_variant_id") {
      const selected_variant_id = this.data.selected_variant_id;
      this.onIdChange(
        selected_variant_id.oldValue,
        selected_variant_id.value
      );
      const selectedVariant = this.getSelectedVariant();
      this.availibilityUpdate(selectedVariant.available);
    } else if (name == "data-product-card-quantity") {
      const quant = this.data.quantity;
      this.onQuantityChange(quant.oldValue, quant.value);
    } else
      ;
  }
  connectedCallback() {
    this.dataStore.listen("product", (data) => {
      this.dataStore.updateMany(new this.newProductData(data.value));
    });
    this.dataStore.listen("quantity", (data) => {
      this.dataStore.update("price", this.getPrice());
    });
    this.dataStore.listen("selected_variant_id", (data) => {
      this.dataStore.update("selected_variant", this.getSelectedVariant());
    });
    this.dataStore.listen("available", (data) => {
      this.availibilityUpdate(data.value);
    });
    this.dataStore.listen("selected_variant", (data) => {
      this.dataStore.update("price", this.getPrice());
      this.dataStore.updateMany({
        available: this.data.selected_variant.value.available
      });
    });
    document.dispatchEvent(
      new CustomEvent("connected:product-card", {
        bubbles: true,
        detail: this
      })
    );
  }
  setProduct(product) {
    this.dataStore.update("product", product);
    this.elements.productDataNode.innerText = JSON.stringify(
      this.data.product.value ?? {}
    );
  }
  UpdateFormData() {
    this.elements.cartForm().formDataAPI.updateItems(this.getItemData());
  }
  setLoadingState() {
    if (this.elements.cartForm().dataset.type === "update") {
      this.classList.add("loading");
    }
  }
  availibilityUpdate(isAvailable) {
    if (isAvailable === false) {
      this.classList.add("not-available");
    } else {
      this.classList.remove("not-available");
    }
  }
  onQuantityChange(old_quantity, new_quantity) {
    this.setLoadingState();
    if (new_quantity === "0" && this.elements.cartForm().dataset.type === "add") {
      this.elements.cartForm().formDataAPI.deleteItem(this.data.selected_variant_id.value);
    } else {
      this.UpdateFormData();
    }
  }
  onIdChange(oldId, newId) {
    this.setLoadingState();
    this.elements.cartForm().formDataAPI.deleteItem(oldId);
    this.UpdateFormData();
  }
  getPrice() {
    const {
      product,
      selected_variant: variant,
      quantity,
      discount = null
    } = this.dataStore.getCurrData();
    const price = variant ? variant.price : product.price;
    return {
      price,
      compare_at_price: (variant == null ? void 0 : variant.compare_at_price) ?? null,
      discounted_price: discount,
      quantity_price: price * quantity,
      discounted_quantity_price: (price - discount) * quantity
    };
  }
  getFirstProductVariant() {
    const { product } = this.dataStore.getCurrData();
    return product.variants[0];
  }
  getSelectedVariant() {
    const { product, selected_variant_id } = this.dataStore.getCurrData();
    return product.variants.filter(
      (_var) => _var.id === selected_variant_id
    )[0];
  }
  getImages() {
    const { product } = this.dataStore.getCurrData();
    const media = product.media;
    const images = product.media.filter(
      (media2) => media2.media_type === "image"
    );
    return {
      media,
      images
    };
  }
}
__publicField(ProductCard, "observedAttributes", [
  "data-product-card-product",
  "data-product-card-price",
  "data-product-card-quantity",
  "data-product-card-selected_variant",
  "data-product-card-selected_variant_id"
]);

class ProductATCButton extends HTMLElement {
  constructor() {
    super();
    this.productCard = this.closest('product-card');
    this.buttonLabel = this.getAttribute('data-button-label');
    this.soldOutLabel = this.getAttribute('data-sold-out-label');
    this.button = this.querySelector('.AddToCart');
  }

  connectedCallback() {
    if (this.productCard) {
      this.observeVariantChanges();
    }
  }

  observeVariantChanges() {
    const observer = new MutationObserver(mutationsList => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-product-card-available') {
          this.handleButtonUpdate();
        }
      }
    });

    observer.observe(this.productCard, { attributes: true, attributeFilter: ['data-product-card-available'] });

    window.addEventListener('beforeunload', () => observer.disconnect());
  }

  handleButtonUpdate() {
    const buttonText = this.button.querySelector(".button-label");
    const isAvailable = this.productCard.getAttribute('data-product-card-available') === "true";

    if (isAvailable) {
      this.button.disabled = false;
      buttonText.innerHTML = this.buttonLabel;
    }
    else {
      this.button.disabled = true;
      buttonText.innerHTML = this.soldOutLabel;
    }
  }
}

function DOMready(callback) {
  if (document.readyState != "loading")
    callback();
  else
    document.addEventListener("DOMContentLoaded", callback);
}
DOMready(() => {
  window.coolDataAPI = coolDataAPI;
  window.themeStore = themeStore$2;
  window.currencyAPIObj = new currencyAPI();
  if (!customElements.get("cart-form")) {
    customElements.define("cart-form", CartForm);
    customElements.define("line-item", LineItem);
  }
  if (!customElements.get("cart-drawer")) {
    customElements.define("price-quote", PriceQuote);
    customElements.define("cart-drawer", CartDrawer);
    customElements.define(
      "cart-drawer-recommendations",
      CartDrawerRecommendations
    );
  }
  if (!customElements.get("product-card")) {
    customElements.define("product-card", ProductCard);
    customElements.define(
      "product-card-product-selector",
      ProductCardProductSelector
    );
    customElements.define(
      "product-card-quantity-selector",
      ProductCardQuantitySelector
    );
    customElements.define("product-card-images", ProductCardImages);
    customElements.define("product-card-add-to-cart", ProductATCButton);
    customElements.define("product-card-price", ProductCardProductPrice);
    customElements.define("product-card-bulk-price", ProductCardCustomBulkPrice);
    customElements.define(
      "product-card-variant-selector",
      ProductCardVariantSelector
    );
  }
  document.dispatchEvent(new CustomEvent("page:loaded"));
});